import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-related-purch-orders',
  templateUrl: './related-purch-orders.component.html',
  styleUrls: ['./related-purch-orders.component.css']
})
export class RelatedPurchOrdersComponent implements OnInit {
    argType;

    argValue;

    public itemsListRelated: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadRelatedPurchaseOrders() {
        if (!!this.argType && !!this.argValue) {
            this.itemsListRelated = await this.datatask.Post(1140, {
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    private async init() {
        this.loadRelatedPurchaseOrders();
    }

    ngOnInit() {
        this.init();
    }
}
